import { ActionConfig } from './action-config.model'
import { Observable, Subject } from 'rxjs'

// TODO: Introduce generic types for params/return results

export abstract class BaseAction {
	abstract readonly id: string
	abstract readonly label: string
	// abstract readonly prefix: ActionPrefix
	// abstract readonly category: string

	private eventsSubject$: Subject<{ event: string; context?: any }> =
		new Subject()

	events$: Observable<any> = this.eventsSubject$.asObservable()

	icon?: string
	description?: string
	keywords?: string[] = []
	shortcut?: string
	disabled = false
	order = 0
	hidden = false

	protected constructor(config?: ActionConfig) {
		if (config) {
			this.icon = config.icon
			this.description = config.description
			this.keywords = config.keywords
			this.shortcut = config.shortcut
			this.disabled = config.disabled ?? false
			this.order = config.order ?? 0
			this.hidden = config.hidden ?? false
		}
	}

	canExecute(): boolean {
		return !this.disabled
	}

	async onBeforeExecute(): Promise<void> {
		// no default action
	}

	async onAfterExecute(result: any): Promise<void> {
		// no default action
	}

	abstract execute(): any | Promise<any>

	async safeExecute(): Promise<any> {
		if (!this.canExecute()) {
			return
		}

		try {
			await this.onBeforeExecute()
			this.eventsSubject$.next({ event: 'BeforeExecute', context: null })

			const result = await this.execute()

			this.eventsSubject$.next({ event: 'AfterExecute', context: result })
			await this.onAfterExecute(result)
			return result
		} catch (error) {
			// TODO: handle error
			throw error
		}
	}
}
